// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetPropertyUnits = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        units: [],
        get_property_units_complete: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        getPropertyUnitsHandler: function(property_id) {

            try {

                // Get the doc
                propertiesModel.doc(property_id).collection('units').where('meta.deleted_at', '==', null).orderBy('attributes.number', 'asc').get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Set the docs prop
                    **  @prop: @here
                    */

                    snapshot.forEach(doc => {

                        this.units.push(doc.data());

                    });
                    
                })
                .then(() => {

                    /*
                    **  Set the completed event prop
                    **  @prop: @here
                    */

                    this.get_property_units_complete = true;

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get Units from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Units',
                        uid: '98nFECq7Mxbus2dKWCk7',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query for Units from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Units',
                    uid: 'lUTvTflB6grLgk25hyNX',
                    error: e
                });

            }

        }

    }

}